<template>
  <div>
    <LetterSearch v-bind:queryParams="queryParams" v-bind:fullDate="fullDate"/>
    <LetterList   v-bind:queryParams="queryParams" v-bind:fullDate="fullDate" v-bind:fieldItems="fieldItems"/>
  </div></template>
<script>


import LetterSearch from './component/LetterSearch';
import LetterList from './component/LetterList';
import DatePicker from 'vue2-datepicker';

const moment = require("moment");
import cSwitch from '../../components/Switch'
export default {
  components: {
    LetterSearch,
    LetterList,
    DatePicker,
    cSwitch
  },
  data() {
    return {
      fullDate: [],
      letterListSelect: false,
      drDeleteRows: [],
      queryParams: {
        start_date: '',
        end_date: '',
        search_type: 'total',
        keyword: '',
      },
      fieldItems: [{
        'selectcheck': {
          'label': '선택',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      },{
        'rnum': {
          'label': '번호',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'active_yn': {
          'label': '노출여부',
          'class': 'text-center',
          'thStyle': {'vertical-align': 'middle'}
        }
      },{
        'letter_code': {
          'label': '뉴스레터 코드',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center'
          }
        }
      }, {
        'nl_subject': {
          'label': '제목',
          'class': 'text-left',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center'
          }
        }
      }, {
        'reg_date': {
          'label': '등록일',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'reg_name': {
          'label': '등록자',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }],
    }
  },
  computed: {
    listRows() {
      return this.items.length
    }
  },
  watch: {
    'letterListSelect'() {
      this.drDeleteRows = [];
    }
  },
  mounted: function() {
     // /contents/trendbrief
     // this.newsLetterInit();
  },
  methods: {
    getFormatDate(date) {
      if (!date) return;
      return moment(date).format("YYYY-MM-DD");
    },
  }
}

</script>




// WEBPACK FOOTER //
// src/views/letter/NewsLetterList.vue